<template>
  <div>
    <header class="pageHeader text-center">
      <div  v-if="!adminApproved" class="pt-10"></div>
      <div id="page-header" class="font-weight-light">{{ pageTitle }}</div>
    </header>  
    <v-container>
      <div v-if="adminApproved">
        <div v-if="showSubCatTiles">
          <SubcategoryTiles :tiles="tiles" />
        </div>
        <div v-if="showFaq">
          <FrequentlyAskedQuestions/>
        </div>
      </div>
    </v-container>
  </div>
</template>
<script>
import jwt_decode from "jwt-decode"
import SubcategoryTiles from '../components/SubcategoryTiles.vue'
import FrequentlyAskedQuestions from '../components/FrequentlyAskedQuestions'

export default {
  name: 'ContentPage',
  components: {
    SubcategoryTiles,
    FrequentlyAskedQuestions
  },
  data: () => ({
    portalHierarchy: [],
    currentPage: {id: null, slug: null},
    showSubCatTiles: false,
    showFaq: false,
    adminApproved: true,
    pageTitle: '',
  }),
  beforeMount () {
    
    this.loadPage()

  },
  mounted (){
  },
  methods: {
    
    async loadPage(){
      this.currentPage = {id: null, slug: null}
      this.showSubCatTiles = false
      this.showFaq = false

      let slug = this.$route.params.slug
      
      const userObj = JSON.parse(localStorage.getItem('rccpcst'))
      const userInfo = jwt_decode(userObj.jwt)
      if(userInfo.ap == 0){
        setTimeout(()=>{
          this.adminApproved = false
          this.overlay = false
          return
        },1000)
      }
      
     
      var endpoint = '/portal/settings'
      const url = process.env.VUE_APP_API_BASE_URL + endpoint

      let postData = {
        action: "navigation"
      }
      
      const request = new Request(url, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + userObj.jwt,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(postData),
        mode: 'cors',
      })
      
      const navJson = await fetch(request)
      .then(response => {
        return response.json();
      })
      .then((jsonResponse) => {
        if(jsonResponse.success) {
          const navResponse = JSON.parse(jsonResponse.data[0]. category_schema_json)
          return navResponse
        }
      })  

      this.portalHierarchy = navJson //[{"category_id":62,"category_name":"Documentation","category_name_display":"Documentation","category_slug":"documentation","category_description":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam mauris ligula, dictum et dolor quis, lobortis gravida dolor.","subcats":[{"category_id":25,"category_name":"User Guides","category_name_display":"User Guides","category_slug":"user-guides","category_description":"View and download instrument instruction for use (IFU) documents and protocol user guides.","subcats":[{"category_id":22,"category_name":"Instruments","category_name_display":"Instruments","category_slug":"instruments","category_description":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam mauris ligula, dictum et dolor quis, lobortis gravida dolor.","subcats":[{"category_id":23,"category_name":"CyteFinder","category_name_display":"CyteFinder","category_slug":"cytefinder","category_description":"","subcats":[]},{"category_id":24,"category_name":"Orion","category_name_display":"Orion","category_slug":"orion","category_description":"","subcats":[]}]},{"category_id":29,"category_name":"Laboratory","category_name_display":"Laboratory","category_slug":"laboratory","category_description":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam mauris ligula, dictum et dolor quis, lobortis gravida dolor.","subcats":[{"category_id":30,"category_name":"Liquid Biopsy","category_name_display":"Liquid Biopsy","category_slug":"liquid-biopsy","category_description":"","subcats":[{"category_id":31,"category_name":"Sample Processing","category_name_display":"Sample Processing","category_slug":"sample-processing","category_description":"","subcats":[]},{"category_id":32,"category_name":"RarePlex Staining","category_name_display":"RarePlex Staining","category_slug":"rareplex-staining","category_description":"","subcats":[]}]},{"category_id":33,"category_name":"Spatial Biology","category_name_display":"Spatial Biology","category_slug":"spatial-biology","category_description":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam mauris ligula, dictum et dolor quis, lobortis gravida dolor.","subcats":[]}]},{"category_id":26,"category_name":"Software","category_name_display":"Software","category_slug":"software","category_description":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam mauris ligula, dictum et dolor quis, lobortis gravida dolor.","subcats":[{"category_id":28,"category_name":"Artemis","category_name_display":"Artemis","category_slug":"artemis","category_description":"","subcats":[]},{"category_id":27,"category_name":"CyteHub","category_name_display":"CyteHub","category_slug":"cytehub","category_description":"","subcats":[]}]}]},{"category_id":38,"category_name":"Certificates of Analysis","category_name_display":"Certificates of Analysis","category_slug":"certificates-of-analysis","category_description":"View and download certificate of analysis documentation.","subcats":[{"category_id":39,"category_name":"AccuCyte (Certs)","category_name_display":"AccuCyte","category_slug":"accucyte","category_description":"","subcats":[]},{"category_id":41,"category_name":"ArgoFluor (Certs)","category_name_display":"ArgoFluor","category_slug":"argofluor","category_description":"","subcats":[]},{"category_id":40,"category_name":"RarePlex (Certs)","category_name_display":"RarePlex","category_slug":"rareplex-certs","category_description":"","subcats":[]}]},{"category_id":34,"category_name":"Safety Data Sheets","category_name_display":"Safety Data Sheets","category_slug":"safety-data-sheets","category_description":"View and download safety data sheet (SDS) documentation for select RareCyte products.","subcats":[{"category_id":35,"category_name":"AccuCyte (SDS)","category_name_display":"AccuCyte","category_slug":"accucyte-sds","category_description":"","subcats":[]},{"category_id":36,"category_name":"RarePlex (SDS)","category_name_display":"RarePlex","category_slug":"rareplex-sds","category_description":"","subcats":[]},{"category_id":37,"category_name":"ArgoFluor (SDS)","category_name_display":"ArgoFluor","category_slug":"argofluor-sds","category_description":"","subcats":[]}]}]},{"category_id":63,"category_name":"Reagent Catalog","category_name_display":"Reagent Catalog","category_slug":"reagent-catalog","category_description":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam mauris ligula, dictum et dolor quis, lobortis gravida dolor.","subcats":[]},{"category_id":64,"category_name":"Support","category_name_display":"Support","category_slug":"support","category_description":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam mauris ligula, dictum et dolor quis, lobortis gravida dolor.","subcats":[{"category_id":65,"category_name":"FAQ","category_name_display":"Frequently Asked Questions","category_slug":"faq","category_description":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam mauris ligula, dictum et dolor quis, lobortis gravida dolor.","subcats":[]}]},{"category_id":66,"category_name":"Resources","category_name_display":"Resources","category_slug":"resources","category_description":"","subcats":[{"category_id":44,"category_name":"Links","category_name_display":"Links","category_slug":"links","category_description":" Useful links to published data and product / news / event information on the RareCyte website.","subcats":[]},{"category_id":45,"category_name":"Videos","category_name_display":"Videos","category_slug":"videos","category_description":"Watch product demonstrations, educational webinars, and training videos for select RareCyte products.","subcats":[]}]}]


      //loop
      let navObj = this.portalHierarchy

      for (let i = 0; i < navObj.length; i++) {
        
        let level1_id = navObj[i].category_id
        let level1_slug = navObj[i].category_slug
        let level1_category_name_display = navObj[i].category_name_display
        let level1_subcats = navObj[i].subcats

        if(slug == level1_slug){ //TOP LEVEL -- GET SUBCAT PAGE WITH TILES
          this.currentPage.id = level1_id
          this.currentPage.slug = level1_slug
          this.pageTitle = level1_category_name_display
          
          // show tiles & get top level docs
          if(level1_subcats.length > 0){
            console.log(`Show Tiles: ${level1_subcats}`)
            this.showSubCatTiles = true
            this.tiles = level1_subcats

            //get top level docs if any

            return
          }
          
          

         
        }else{
          // check if second level w/sub
          if(level1_subcats.length > 0){
            
            for (let ii = 0; ii < level1_subcats.length; ii++) {

              let level2_id = level1_subcats[ii].category_id
              let level2_slug = level1_subcats[ii].category_slug
              let level2_subcats = level1_subcats[ii].subcats
              let level2_category_name_display = level1_subcats[ii].category_name_display
        
              if(slug == level2_slug){

                this.currentPage.id = level2_id
                this.currentPage.slug = level2_slug
                this.pageTitle = level2_category_name_display

                if(level2_slug=== 'faq' || level2_slug=== 'frequently-asked-questions'){
                  this.showFaq = true
                  return
                }

                

                if(level2_subcats.length > 0){

                  console.log(`Show Tiles For Sub: ${level2_subcats}`)
                  this.showSubCatTiles = true
                  this.tiles = level2_subcats

                  //get top level docs if any

                  return
                }

              }else{
                // if(level2_subcats.length > 0){
                //   for (let iii = 0; iii < level2_subcats.length; iii++) {
                //     let level3_id = level1_subcats[iii].category_id
                //     let level3_slug = level1_subcats[iii].category_slug
                //     let level3_subcats = level1_subcats[iii].subcats

                //     if(slug == level3_slug){

                //       this.currentPage.id = level3_id
                //       this.currentPage.slug = level3_slug

                //       console.log(level3_id, level3_slug, level3_subcats)
                //       //get docs
                //       return
                //     }

                //   }
                // }
              }

            }
          }
        }

        

      }

    
    },
    getHierarchy(){

    },
  },
  watch:{
    $route (){

      this.loadPage()
    }  
  } 
}
</script>
<style lang="scss" scoped>

.filter-header{
  color:#53565b;
}
.subnav-link{
  text-decoration: none;
}
header.pageHeader{
  color: #fff;
  width: 100%;
  height: 200px;
  background: url( '../assets/portal-header-bg-3.jpg') no-repeat center top;
  background-size: cover;
  margin-top:-64px;
  
  margin-bottom:50px;
}
#page-header{
  font-size: 2.7rem;
  text-transform: uppercase;
  padding-top:60px;
}
.icon-box{
  height:30px;
  width: 30px;
  text-align: center;
  line-height: 30px;
}

@media only screen and (max-width: 1024px) {
  header.pageHeader{
    width: 100%;
    height: 200px;
    background: url( '../assets/header-bg.png') no-repeat center top;
    background-size: cover;
    margin-top:0px;
    color: #fff;
    padding-top: 20px;
    margin-bottom:50px;
  }
  #page-header{
    font-size: 1.6rem;
    text-transform: uppercase;
  }
}

</style>
